<script>
// Bubble decoration aligned with Net_Web_GameVue FlipMatch/components/BubbleLayer.vue (ADO 875950).
export default {
    name: 'MissionMatchBubbleLayer',
    computed: {
        bubbles: function () {
            var count = 24
            var list = []
            for (var i = 0; i < count; i++) {
                var size = 4 + ((i * 7) % 11)
                var left = (i * 41) % 100
                var bottom = (i * 13) % 90
                var delay = (i / count) * 8
                list.push({
                    id: i,
                    style: {
                        width: size + 'px',
                        height: size + 'px',
                        left: left + '%',
                        bottom: bottom + '%',
                        animationDelay: '-' + delay.toFixed(2) + 's',
                    }
                })
            }
            return list
        }
    }
}
</script>

<template>
    <div class="bubble-layer" data-cy="mission_match_bubble_layer">
        <span
            v-for="b in bubbles"
            :key="b.id"
            class="bubble"
            :style="b.style"
        ></span>
    </div>
</template>

<style lang="scss" scoped>
.bubble-layer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 34%;
    overflow: hidden;
    pointer-events: none;
    z-index: 0;
}

.bubble {
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.4);
    animation-name: mission-match-bubble-bloom;
    animation-duration: 8s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}

@keyframes mission-match-bubble-bloom {
    0%, 7.5%, 100% {
        opacity: 0;
        transform: scale(0.5) translateY(0);
    }
    13.6% {
        opacity: 1;
        transform: scale(1) translateY(-4px);
        animation-timing-function: linear;
    }
    32.8% {
        opacity: 1;
        transform: scale(1) translateY(-8px);
    }
    43.3% {
        opacity: 0;
        transform: scale(0.5) translateY(-10px);
    }
}
</style>
